import * as React from 'react';
import Grid from '@mui/material/Grid';

import DayTimeRangeComponent from './DayTimeRange';
import TopicGradeComponent from './TopicGrade';
import LocationsPossibleComponent from './LocationsPossible';
import TimeRangeSlider from './TimeRangeSliderComponent';
import SelectNumberStudents from './NumberOfStudents';
import { NewStudentAvailability } from './application/Availability';

const Skills = ({ userId }) => {
  return (
    <React.Fragment>
      <Grid container maxWidth="xxl" spacing={2}>
        <Grid item xs={12} sm={12} md={6} lg={5}>
          <DayTimeRangeComponent userSelected={userId} />
          <SelectNumberStudents userId={userId} />
          <TimeRangeSlider userSelected={userId} userLogged />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4}>
          <TopicGradeComponent userSelected={userId} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={3}>
          {/* <LocationSkill/> */}
          <LocationsPossibleComponent userSelected={userId} />
          <NewStudentAvailability userId={userId} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Skills;
